/* DryWell extras: stacking "shop by problem" cards and one-tap add to cart. */
(() => {
  'use strict';
  const D = window.Drywell || {};
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function initStack(section) {
    if (reduced || typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    const cards = $$('.stack__card', section);
    cards.forEach((card, i) => {
      const img = $('.stack__scene-img', card);
      if (img) {
        gsap.fromTo(img, { yPercent: -6, scale: 1.12 }, {
          yPercent: 6, scale: 1, ease: 'none',
          scrollTrigger: { trigger: card, start: 'top bottom', end: 'bottom top', scrub: true }
        });
      }
      const next = cards[i + 1];
      if (!next) return;
      gsap.to(card, {
        scale: 0.9 + i * 0.006, filter: 'brightness(0.72)', ease: 'none',
        scrollTrigger: { trigger: next, start: 'top bottom', end: 'top 20%', scrub: true }
      });
    });
  }

  // Add to cart without leaving the page, then open the cart drawer.
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-quick-add]');
    if (!form || (D.settings && D.settings.cartType === 'page')) return;
    e.preventDefault();
    const btn = $('button', form);
    const label = $('.btn__label', btn) || btn;
    const original = label.textContent;
    btn.disabled = true;
    label.textContent = (D.strings && D.strings.adding) || 'Adding…';
    try {
      const res = await fetch(((D.routes && D.routes.cartAdd) || '/cart/add') + '.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
      label.textContent = (D.strings && D.strings.added) || 'Added';
      const opener = $('[data-cart-open]');
      if (opener) opener.click(); else window.location.href = (D.routes && D.routes.cart) || '/cart';
    } catch (err) {
      label.textContent = err.message;
    } finally {
      setTimeout(() => { btn.disabled = false; label.textContent = original; }, 1600);
    }
  });

  const boot = () => {
    $$('[data-section-type="stack"]').forEach(initStack);
    if (window.ScrollTrigger) setTimeout(() => ScrollTrigger.refresh(), 300);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-section-type="stack"]');
    if (el) initStack(el);
  });
})();
